import React from "react";
import { RaisedButton } from "material-ui";

import OrderTable from "./partials/order-table.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";

import BackButton from "./partials/back-button.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import CouponActions from "../actions/CouponActions";
import CouponStore from "../stores/CouponStore";
import UserStore from "../stores/UserStore";
import { snakeCase } from "../util";

class Coupon extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      coupon: null,
      uses: [],
      isFetchingCoupon: false,
      fetchedCoupon: null
    };
  }

  static getStores() {
    return [CouponStore, UserStore];
  }

  static getPropsFromStores() {
    return {
      getCouponById: CouponStore.getCouponById,
      getCouponUsesById: CouponStore.getCouponUsesById,
      isFetchingUses: CouponStore.getState().isFetchingUses
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    var coupon = newProps.getCouponById(newProps.params.couponId),
      uses = newProps.getCouponUsesById(newProps.params.couponId);

    if (
      !this.state.isFetchingCoupon &&
      this.state.fetchedCoupon !== newProps.params.couponId
    ) {
      setTimeout(() => {
        CouponActions.fetchOne(newProps.params.couponId);
        CouponActions.fetchUses(newProps.params.couponId);
      }, 0);
      this.setState({ isFetchingCoupon: true });
    } else if (coupon && uses.length) {
      this.setState({ isFetchingCoupon: false, fetchedCoupon: coupon.id });
    }

    this.setState({ coupon, uses });
  }

  getStyles() {
    return {
      button: {
        marginLeft: 7
      },
      h2: {
        marginTop: 20
      }
    };
  }

  render() {
    var styles = this.getStyles();

    if (!this.state.coupon) {
      return <WorkingIndicator fullPage={true} />;
    }

    return (
      <div>
        <div style={{ marginBottom: 20 }}>
          <BackButton
            label={"discounts"}
            onTouchTap={() =>
              this.props.location.state && this.props.location.state.fromListing
                ? this.context.router.goBack()
                : this.context.router.push(
                    `/event_buckets/${this.props.params.eventBucketId}/coupons`
                  )
            }
          />
          {UserStore.hasPermission("edit_coupon") ? (
            <RaisedButton
              label="Edit discount"
              onTouchTap={() =>
                this.context.router.push(
                  `/event_buckets/${this.props.params.eventBucketId}/coupons/${this.props.params.couponId}/edit`
                )
              }
              style={styles.button}
            />
          ) : null}
        </div>
        <h1>{this.state.coupon.name}</h1>
        <div>
          <strong>
            {this.state.coupon.active
              ? "Currently active"
              : "Currently inactive"}
          </strong>
          <br />
          {this.state.coupon.multicode
            ? "Multiple codes"
            : `Code: ${this.state.coupon.code}`}{" "}
          | Total uses: {this.state.uses.length}
        </div>
        <h2 style={styles.h2}>Discount uses</h2>
        <OrderTable
          orders={this.state.uses}
          showCouponCode={this.state.coupon.multicode}
          hideNoOrdersMessage={this.props.isFetchingUses}
          showDownloadButton={true}
          downloadCsvFileLabel={`coupon-uses-${snakeCase(
            this.state.coupon.name
          )}`}
        />
      </div>
    );
  }
}

export default connectToStores(Coupon);



// WEBPACK FOOTER //
// ./src/app/components/coupon.jsx